module.exports = __webpack_public_path__ + "media/images/stanford_on_broadway/KathleenDeco-8aa1dfc0fa158927d1cbd4966f8974e5.png";